import { type FC } from 'react';
import SelectCustom from '2-core-elements/FormElements/SelectCustom';
import { type ActiveFilter, type FilterItem } from './ListingFiltersTypes';
import { getActiveFilterValueByField, getUpdatedFilters } from './ListingFilterHelpers';

// this component the default select behaviour
// get the placeholder and field from filters
// on change set the activeFilters value of the same field

interface ListingFilterSelectProps {
    placeholder: string;
    field: string;
    activeFilters: ActiveFilter[]; // current filter that is active (selected)
    setActiveFilters: (newFilters: ActiveFilter[]) => void; // function to update active filters
    items: FilterItem[];
    disabled?: boolean;
}

const ListingFilterSelect: FC<ListingFilterSelectProps> = ({ placeholder, field, activeFilters, setActiveFilters, items, disabled }) => {
    // set the option for select element (label and value have same value)
    const options = items.map(({ label, value, nestingLevel }) => {
        return { label, value, nestingLevel };
    });

    // find the activeFilter Filters value (string[])
    const activeFilterValue = getActiveFilterValueByField(activeFilters, field);

    // always get [0] since single value
    const selectValue = activeFilterValue[0] ? {
        label: items.find(item => {
            return activeFilterValue[0] === item.value;
        })?.label || activeFilterValue[0], value: activeFilterValue[0],
    } : null;

    return (
        <div className="listing-app-filter-item">
            <SelectCustom
                placeholder={placeholder}
                options={options}
                value={selectValue}
                disabled={disabled}
                onChange={(optionValue): void => {
                    setActiveFilters(
                        getUpdatedFilters(activeFilters, field, optionValue ? [optionValue.value] : [])
                    );
                }}
                className="listing-filter-element"
            />
        </div>
    );
};

export default ListingFilterSelect;
